"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMenuItem = exports.StyledSortingList = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledSortingList = (0, styled_components_1.default)(ui_components_1.Dropdown) `
  &&& {
    background-color: ${({ theme }) => theme.palette.common.white};
    color: ${({ theme }) => theme.palette.text.secondary};
    font-size: 0.875rem;

    .MuiOutlinedInput-input {
      padding-right: ${({ theme }) => theme.spacing(4)};
      padding-left: 0;
      padding-top: 0;
      padding-bottom: 0;
      font-size: 0.8rem;
    }

    &:hover .MuiSelect-icon {
        background: none;
      }

    .MuiSelect-icon {
      right: 0;

      svg > path {
        fill: ${({ theme }) => theme.palette.grey[400]};
      }
    }

    .MuiOutlinedInput-notchedOutline {
      border: none;
      padding: 0;

      &:hover {
        border-color: ${ui_components_1.baseColors.primaryGray200};
      }
    }
  }
`;
exports.StyledMenuItem = (0, styled_components_1.default)(ui_components_1.MenuItem) `
  border-radius: 4px;
  font-size: 0.875rem;

  &&.Mui-selected {
    background-color: ${ui_components_1.baseColors.primaryGreen001};
  }
`;
